import { render, staticRenderFns } from "./activityRules.vue?vue&type=template&id=69531264&scoped=true"
import script from "./activityRules.vue?vue&type=script&lang=js"
export * from "./activityRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69531264",
  null
  
)

export default component.exports